import React, { useState, useEffect } from "react"
import { promoURL2 } from "../../App"
import { useGlobalContext } from "../data/GlobalContext"

export default function PromotionBar() {
  const { username } = useGlobalContext()
  const [isOpen, setIsOpen] = useState(false)
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const [showButton, setShowButton] = useState(false)
  const [turnover, setTurnOver] = useState("")
  const [progress, setProgress] = useState(0)
  const MAX_TURNOVER = 5000

  useEffect(() => {
    const now = new Date()
    const targetDate = new Date("2025-05-03T12:00:00")

    if (now >= targetDate) {
      setShowButton(true)
    }
  }, [])

  useEffect(() => {
    if (!isLoggedIn) return
    fetch(promoURL2, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
      body: `cmd=getBNGTurnover&u=${username}`,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data?.turnover) {
          setTurnOver(data.turnover)
          setProgress(Math.min(data.turnover, MAX_TURNOVER))
        } else {
          console.error("No turnover data found.")
        }
      })
      .catch((error) => {
        console.error("Error fetching commission data:", error)
      })
  }, [isLoggedIn, username])

  useEffect(() => {
    const loggedIn = localStorage.getItem("isLoggedIn") === "true"
    setIsLoggedIn(loggedIn)
  }, [])

  if (!isLoggedIn) {
    return null
  }

  const handleOpen = () => setIsOpen(true)
  const handleClose = () => setIsOpen(false)

  return (
    <>
      {showButton && (
        <button
          className="progress-icon"
          onClick={handleOpen}
          title="Show Progress Bar"
          type="button"
        >
          Turnover
        </button>
      )}

      {isOpen && (
        <div className="spin-surprise-overlay-container">
          <div className="spin-surprise-bar-content">
            <div className="spin-surprize-element">
              <img src="/images/character/CLOVER.webp" alt="" />
            </div>
            <div className="spin-surprize-element-1">
              <img src="/images/character/CLOVER.webp" alt="" />
            </div>
            <div className="spin-surprize-character">
              <img src="/images/character/SPIN_SURPRIZE-TURNOVER.webp" alt="" />
            </div>
            <div>
              <h1>Turnover</h1>
              <div className="spin-surprize-bar">
                <div
                  className="spin-surprize-bar-progress"
                  style={{
                    width: `${(progress / MAX_TURNOVER) * 100}%`,
                    transition: "width 0.5s ease",
                  }}
                />
              </div>
              <p className="spin-surprize-desc" style={{ color: "#fff" }}>
                Play any BNG slots to qualify in a weekly draw - every Sat, 3PM.
              </p>
              <p className="spin-surprize-progress" style={{ color: "#fff" }}>
                {progress.toLocaleString()} / 5,000 turnover
              </p>

              {progress >= MAX_TURNOVER && (
                <p
                  style={{
                    color: "#FFD700",
                    marginTop: "10px",
                    fontSize: "0.775rem",
                  }}
                >
                  🎉 You got a chance to win FREE SPINS!
                </p>
              )}
            </div>

            <button
              onClick={handleClose}
              className="close-button"
              type="button"
            >
              CLOSE
            </button>
          </div>
        </div>
      )}
    </>
  )
}
